import { memo } from "react"
import Head from "next/head"
import PropTypes from "prop-types"

// Turn a raw HTML string containing one or more <script> tags into real
const renderHeaderScripts = html => {
  if (!html) return null
  const tagRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi
  return Array.from(html.matchAll(tagRegex)).map(([raw, attrsStr, content]) => {
    const attrs = {}
    attrsStr.replace(/([\w:-]+)(?:\s*=\s*"([^"]*)")?/g, (_, name, value) => {
      attrs[name === "charset" ? "charSet" : name] = value ?? true
    })
    return (
      <script
        key={raw}
        {...attrs}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  })
}

const CustomHead = ({ seoMetaData, scripts }) => {
  const {
    canonicalUrl,
    pageTitle,
    ogTitle,
    pageDescription,
    ogDescription,
    ogType,
    ogUrl,
    ogImage,
    keywords,
    noIndexNoFollow,
  } = seoMetaData?.fields || {}
  const shouldNoIndex =
    Boolean(process.env.NEXT_PUBLIC_LOWER_ENV_TAG) || noIndexNoFollow === true
  return (
    <Head>
      <title>{pageTitle}</title>
      <link
        rel="canonical"
        href={canonicalUrl}
        hrefLang={seoMetaData?.sys?.locale}
      />
      <link rel="icon" href="/kohler-favicon.png" />
      {shouldNoIndex && (
        <meta key="robots" name="robots" content="noindex, nofollow" />
      )}
      <meta name="description" content={pageDescription}></meta>
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage?.fields?.file?.url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={ogUrl} />
      <meta name="keywords" content={keywords} />
      <meta charSet="utf-8" />
      {/* one trust cookie script starts */}
      {/* <script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/29e9d447-96cb-4b2d-87be-2141feb07d99/OtAutoBlock.js"
        async
      /> */}
      {scripts && renderHeaderScripts(scripts)}
    </Head>
  )
}

CustomHead.propTypes = {
  seoMetaData: PropTypes.shape({
    fields: PropTypes.shape({
      canonicalUrl: PropTypes.string,
      pageTitle: PropTypes.string,
      ogTitle: PropTypes.string,
      pageDescription: PropTypes.string,
      ogDescription: PropTypes.string,
      ogType: PropTypes.string,
      ogUrl: PropTypes.string,
      ogImage: PropTypes.shape({
        fields: PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
      }),
      keywords: PropTypes.string,
      noIndexNoFollow: PropTypes.bool,
    }),
    sys: PropTypes.shape({
      locale: PropTypes.string,
    }),
  }),
}

export default memo(CustomHead)
